import { useTranslations } from 'next-intl'

import {
  AccountToastProvider,
  useGuestDepositReturnAccount,
} from '@/features/update-account'
import { cn } from '@/shared/lib'
import { Dialog } from '@/shared/ui'

import { UpdateDepositReturnAccountForm } from './form'

type Props = {
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
  contractId: number
  onSuccess?: () => void
  onClose?: () => void
}

export const UpdateDepositReturnAccountDialog = ({
  isOpen,
  onOpenChange,
  contractId,
  onSuccess,
  onClose,
}: Props) => {
  const t = useTranslations('deposit_information')

  const { depositReturnAccount } = useGuestDepositReturnAccount({
    contractId,
  })

  const isFormEditable = depositReturnAccount?.isEditAvailable

  const handleOpenChange = (open: boolean) => {
    if (isFormEditable && !open) {
      return
    }

    onOpenChange(open)
  }

  const handleClose = () => {
    if (isFormEditable) {
      onClose?.()
    } else {
      onOpenChange(false)
    }
  }

  return (
    <Dialog.Root open={isOpen} onOpenChange={handleOpenChange}>
      <Dialog.Content
        className={cn('gap-0 p-0', {
          'h-[424px]': isFormEditable,
          'h-[262px]': !isFormEditable,
        })}
        onClose={handleClose}
      >
        <Dialog.Header className="p-6">
          <Dialog.Title className="text-start">{t('title')}</Dialog.Title>
        </Dialog.Header>
        <AccountToastProvider />
        <UpdateDepositReturnAccountForm
          contractId={contractId}
          onSuccess={onSuccess}
          onClose={handleClose}
        />
      </Dialog.Content>
    </Dialog.Root>
  )
}
